import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-008da956"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center" }




export default /*#__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
  title: {
    type: String,
    required: false,
  },
  text: {
    type: String,
    required: false,
  },
  icon: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    class: "mainCard"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex flex-align pt-3 pl-6" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            icon: "",
            variant: "text",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('iconClicked')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.icon), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "pl-6" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "text", {}, () => [
            _createTextVNode(_toDisplayString(__props.text), 1)
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})